import { render, staticRenderFns } from "./ChoosePosition.vue?vue&type=template&id=7182c653&scoped=true"
import script from "./ChoosePosition.vue?vue&type=script&lang=ts"
export * from "./ChoosePosition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182c653",
  null
  
)

export default component.exports